import { INIT } from "../action_types";
import * as FilterActions from "./filter.actions";
import * as ModelsActions from "./models.actions";
import * as ProfileActions from "./profile.actions";

export function init(saved_state = {}) {
  return {
    state: saved_state,
    type: INIT
  }
}

export { ProfileActions, ModelsActions, FilterActions };

